import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { BitwerxPluginCardProps } from './types';
import { Button, Chip } from '@v2/components';
import { styles } from './styles';

const BitwerxPluginCard: React.FC<BitwerxPluginCardProps> = ({ plugin, onDelete }) => {
  const version = plugin.defaultPluginVersion;
  const pimsDeps = plugin.pimsDependencies ?? [];
  const pimsLabels = pimsDeps.map(d => d.pims || d.pimVersion).filter(Boolean);
  const description = version?.description || plugin.description || null;

  return (
    <div className={styles.container}>
      {onDelete && (
        <div className={styles.deleteButton}>
          <Button
            variant="ghost-danger"
            size="sm"
            onClick={() => onDelete(plugin)}
            aria-label={`Delete ${plugin.name}`}
            icon={<FontAwesomeIcon icon={faTrash} />}
          />
        </div>
      )}
      <div className={styles.row}>
        <span className={styles.label}>Plugin Name</span>
        <span className={styles.value}>{plugin.name}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>Default Version</span>
        <span className={styles.value}>{version?.version ?? '—'}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>Description</span>
        <span className={styles.value}>{description || '—'}</span>
      </div>
      <div className={styles.row}>
        <span className={styles.label}>Release Date</span>
        <span className={styles.value}>{version?.releaseDate ?? '—'}</span>
      </div>
      <div className={styles.dependencies}>
        <span className={styles.dependenciesLabel}>Supported Pims Dependencies</span>
        {pimsLabels.length > 0 ? (
          <div className={styles.chips}>
            {pimsLabels.map((pim, i) => (
              <Chip key={`pim-${i}`} variant="neutral" size="sm">
                {pim}
              </Chip>
            ))}
          </div>
        ) : (
          <span className={styles.value}>—</span>
        )}
      </div>
    </div>
  );
};

export default BitwerxPluginCard;
